import { cust } from "api/endpoints";
import { importView } from "../utils/misc";

const PersonList = importView("Person/List");
const PersonForm = importView("Person/Form");
const OrgList = importView("Org/List");
const OrgForm = importView("Org/Form");
const Business = importView("Business");
const Profs = importView("Profession");
const Education = importView("Education");
const InfoSrc = importView("InfoSrc");
const RelType = importView("RelationType");

const custRoutes = {
  path: "/admin/cust/",
  children: [
    {
      path: cust.businesses,
      element: <Business />,
    },
    {
      path: cust.educations,
      element: <Education />,
    },
    {
      path: cust.infoSrcs,
      element: <InfoSrc />,
    },
    {
      path: cust.relationType,
      element: <RelType />,
    },
    {
      path: cust.professions,
      element: <Profs />,
    },
    {
      path: cust.persons,
      element: <PersonList />,
    },
    {
      path: `${cust.person}/:CustCode`,
      element: <PersonForm />,
    },
    {
      path: cust.orgs,
      element: <OrgList />,
    },
    {
      path: `${cust.org}/:CustCode`,
      element: <OrgForm />,
    },
  ],
};

export default custRoutes;
